import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import * as Constants from '../Shared/Constants.js'
import CommentsList from '../Shared/CommentsList/CommentsList.js'
import MedboardPdf from '../MedboardPdf/MedboardPdf.jsx';
import { Tags } from '../Shared/Tags.js'
import TaskManager from '../TaskManager/TaskManager.js';
import { EventEmitter } from "events";
import EntityAssociation from "../Shared/EntityAssociation.js";
import AIChat from '../AIChat/AIChat.js';
import '../Shared/Style.css';
import Attachments from "../Shared/Attachments.js";
import Audit from "../Shared/Audit.js";
import { useDropzone } from 'react-dropzone';
import RelatedLegalManufacturers from "../Shared/RelatedLegalManufacturers.js";
import ComplianceComparison from "../Shared/ComplianceComparison.js";



const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [screenType, setScreenType] = useState("main"); // main | comparison
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("information");
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [selectedPDFTab, setSelectedPDFTab] = useState("main");
    const [requestingTranslation, setRequestingTranslation] = useState(false);
    const [requestedTranslation, setRequestedTranslation] = useState(false);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [showDeleteFileConfirmation, setShowDeleteFileConfirmation] = useState(false);
    const [isDeletingFile, setIsDeletingFile] = useState(false);
    const [currentLegalManufacturer, setCurrentLegalManufacturer] = useState("");
    const [selectedPDFVersion, setSelectedPDFVersion] = useState(null);
    const [isVersionDropdownOpen, setIsVersionDropdownOpen] = React.useState(false);
    const [taskManagerExternalLinkedObjects, setTaskManagerExternalLinkedObjects] = useState([]);
    const [isVersionComparisonDropdownOpen, setIsVersionComparisonDropdownOpen] = useState(false);
    const [selectedPDFVersionComparison, setSelectedPDFVersionComparison] = useState(null);
    


    const [isEditingField, setIsEditingField] = useState({
        name: false,
    });


    const compliance_statuses = Constants.ComplianceStatuses;

    const currentItemNameRef = useRef(null);
    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);
    const versionsMenuButton = useRef(null);
    const versionsMenuOptions = useRef(null);
    const versionsComparisonMenuButton = useRef(null);
    const versionsComparisonMenuOptions = useRef(null);

    //const firstEmitter = new EventEmitter(); 
    //const secondEmitter = new EventEmitter(); 


    const firstEmitterRef = useRef(new EventEmitter());
    const firstEmitter = firstEmitterRef.current;

    //const secondEmitterRef = useRef(new EventEmitter());
    //const secondEmitter = secondEmitterRef.current;




    const saveCurrentItem = () => {
        // Validations

        let isValidForm = true;

        //setErrorCurrentItemName(false);

        //if (!validFormField(currentItem.Name, setErrorCurrentItemName)) isValidForm = false;

        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        AppContext.disableAllItemFormFieldsEdit();

        // Update item remotely and if successful...

        let currentItem = AppContext.currentItem;

        currentItem.Entities = AppContext.linkedObjectsList;

        //AppContext.setCurrentItem(currentItem);

        let updateItemURL = AppContext.dataUrl;

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(currentItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );

                    AppContext.setCurrentItem(result);

                    AppContext.setData(updatedDataArray);
                    setIsShowingSaveMessage(true);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };


    const callAIChat = () => {

        setAutoCallOverviewFunction(true);
        setVisibleDetailsTab("aichat");
        setComponentKey(prevKey => prevKey + 1); // restart AIChat component
    }



    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);


    const reinitialize = () => {
        setVisibleDetailsTab("information");
        setAutoCallOverviewFunction(false);
        setSelectedPDFTab("main");
        setIsUploadingFile(false);
        setIsDeletingFile(false);
        setIsSavingItem(false);
        setRequestedTranslation(false);
        AppContext.setIsShowingDeleteConfirmation(false);
    }


    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);


    useEffect(() => {

        if(!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);

    }, [itemDetailsPaneOpenEffect])




    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };



    useEffect(() => {

        const handleClickOutside = (e) => {

            if (
                contextMenuButton.current && contextMenuButton.current.contains(e.target) ||
                contextMenu.current && contextMenu.current.contains(e.target) ||
                versionsMenuButton.current && versionsMenuButton.current.contains(e.target) ||
                versionsMenuOptions.current && versionsMenuOptions.current.contains(e.target) ||
                versionsComparisonMenuButton.current && versionsComparisonMenuButton.current.contains(e.target) ||
                versionsComparisonMenuOptions.current && versionsComparisonMenuOptions.current.contains(e.target)
            )
                return;

            setIsVersionDropdownOpen(false);
            setShowItemContextMenu(false);
            AppContext.setIsShowingDeleteConfirmation(false);

        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (AppContext.currentItem?.OtherVersions) {
            const version = AppContext.currentItem.OtherVersions.find(
                x => x.UniqueId === AppContext.currentItem.UniqueId
            );

            setSelectedPDFVersion(version || null);
        } else {
            setSelectedPDFVersion(null);
        }


        // Add external linked objects for task manager

        if (AppContext.currentItem) {
            let TMExternalLinkedObjects = [
                { EntityType: "compliance-regulatorydocuments", EntityId: AppContext.currentItem.Id }
            ];

            let taskManagerCountryId = AppContext.currentItem.CountryId;

            if (taskManagerCountryId)
                TMExternalLinkedObjects.push({ EntityType: "countryregistration-country", EntityId: taskManagerCountryId });

            setTaskManagerExternalLinkedObjects(TMExternalLinkedObjects);
        }


    }, [AppContext.currentItem]);


    const requestPDFTranslation = () => {

        let requestTranslationUrl = "/umbraco/api/DynamicTable/CreateTranslationRequest?surveillanceIdent=" + AppContext.currentItem.UniqueId + "&complianceManager=true";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            dataType: 'text',
        };

        setRequestingTranslation(true);
        setRequestedTranslation(false);

        fetch(requestTranslationUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((result) => {
                setRequestingTranslation(false);
                setRequestedTranslation(true);

            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
            });

    }

    const hasValue = (field) => {

        if (field != null && field != "")
            return true;

        return false;
    }







    
    const onDrop = useCallback((acceptedFiles) => {

        const formData = new FormData();
        acceptedFiles.forEach(file => formData.append('files', file));

        let requestOptions = {
            method: 'POST',
            body: formData,
        };


        setIsUploadingFile(true);

        let attachmentUrl = "/Umbraco/Api/Compliance/Upload/?complianceType=" + AppContext.ComplianceType + "&uniqueId=" + AppContext.currentItem.UniqueId;

        fetch(attachmentUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {

                    // Update item
                    AppContext.setCurrentItem({ ...AppContext.currentItem, MedboardResourceId: data });

                    // Update list
                    // Update list
                    AppContext.setData(list =>
                        list.map(item =>
                            item.Id == AppContext.currentItem.Id ? { ...item, MedboardResourceId: data } : item
                        )
                    );
                    
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsUploadingFile(false);
            });

    }, [AppContext.currentItem]);



    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': [], // PDF
        },
        multiple: false,
    });




    const deleteCurrentFile = () => {

        let deleteFileUrl = "/Umbraco/Api/Compliance/Upload/?complianceType=" + AppContext.ComplianceType + "&uniqueId=" + AppContext.currentItem.UniqueId;

        let requestOptions = {
            method: 'DELETE',
        };

        setIsDeletingFile(true);

        fetch(deleteFileUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((data) => {

                // Update item
                AppContext.setCurrentItem({ ...AppContext.currentItem, MedboardResourceId: null });

                // Update list
                AppContext.setData(list =>
                    list.map(item =>
                        item.Id == AppContext.currentItem.Id ? { ...item, MedboardResourceId: null } : item
                    )
                );

                setShowDeleteFileConfirmation(false);
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsDeletingFile(false);
            });
    }




    useEffect(() => {

        if (AppContext.currentItem && AppContext.legalManufacturers.length) {

            let lm = AppContext.legalManufacturers.find(lm => lm.EstablishmentId == AppContext.currentItem.LegalManufacturerId);

            if (lm)
                setCurrentLegalManufacturer(lm.Establishment);
            else
                setCurrentLegalManufacturer("");
        }

    }, [AppContext.currentItem, AppContext.legalManufacturers]);




    const closeComplianceComparisonPopup = () => {

        setSelectedPDFVersionComparison(null);
        setScreenType("main");
    }






    let hasPdfFile = AppContext.currentItem != null &&
        (
            (AppContext.currentItem.MediaPath != null && AppContext.currentItem.MediaPath != "") ||
            (AppContext.currentItem.MedboardResourceId != null && AppContext.currentItem.MedboardResourceId != "")
        );

    let hasAIChat = hasPdfFile;

    let fullWidthPane = hasPdfFile || hasAIChat;

    const entryDate = (AppContext.currentItem && AppContext.currentItem.EntryIntoForceDate)
    const endDate = (AppContext.currentItem && AppContext.currentItem.EndDate)


    

    return (
        <>

            {itemDetailsPaneActive ? 
                
                <div
                    style={{ height: "100vh", overflow: "auto" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content" >
                

                        <div style={{ flex: "1" }}>

                            {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                                <>
                                    <div>
                                        <LoadingSpinnerImage />
                                    </div>
                                </>
                            ) : (
                                    <>


                                    {/* INFORMATION MAIN SCREEN */}
                                    {/* INFORMATION MAIN SCREEN */}
                                    {/* INFORMATION MAIN SCREEN */}


                                    {screenType == "main" ?

                                        <div style={{ display: "flex", flexDirection: "row" }}>


                                            {/* PDF PANE */}
                                            {/* PDF PANE */}
                                            {/* PDF PANE */}

                                            {hasPdfFile ? <>
                                                <div id="pdf-viewer" style={{ flex: 25, paddingRight: "10px", borderRight: "2px solid #f0f0f0", height: "96vh" }}>

                                                    <div style={{ display: "flex", flexDirection: "row", width: "100%", marginBottom: "5px" }}>
                                                        <div style={{ flex: 1 }}>
                                                            <h3>PDF Viewer</h3>
                                                        </div>
                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "end", marginRight: "50px" }}>


                                                            {AppContext.currentItem.MediaPathIsEnglish == 0 && AppContext.currentItem.TranslationMediaPath == "" ? <>
                                                               
                                                                {requestedTranslation ? <>
                                                                    <div class="g-mr-10">Translation has been successfully requested. It will be ready here in few minutes. Please refresh the page to see it.</div>
                                                                    </> : <div>
                                                                        <button className="data-request-pdf-translation-cm g-mr-20" onClick={requestPDFTranslation}><i className="fas fa-language g-mr-5"></i> Request translation</button>
                                                                    </div>}
                                                            </> : null}
                                                            {AppContext.currentItem.ShowVersionHistory === true && (
                                                                <>
                                                                    <div className="compliance-version-dropdown g-mr-20">
                                                                        <button
                                                                            ref={versionsMenuButton}
                                                                            className="compliance-version-button"
                                                                            onClick={() => setIsVersionDropdownOpen(prev => !prev)}
                                                                            title="Select another version to display"
                                                                        >
                                                                            <i className="far fa-file-archive g-mr-5"></i>
                                                                            {selectedPDFVersion?.UniqueId === AppContext.currentItem?.UniqueId
                                                                                ? "Version History"
                                                                                : selectedPDFVersion?.Title || "Version History"}
                                                                            <i className="fas fa-caret-down g-ml-5"></i>
                                                                        </button>

                                                                        {isVersionDropdownOpen && (
                                                                            <ul className="compliance-version-dropdown-menu" ref={versionsMenuOptions}>
                                                                                {AppContext.currentItem.OtherVersions.filter(v => v.MediaPath && v.MediaPath !== "").map(v => {
                                                                                    const isSelected = v.UniqueId === selectedPDFVersion?.UniqueId;
                                                                                    return (
                                                                                        <li
                                                                                            key={v.UniqueId}
                                                                                            className={isSelected ? "selected disabled" : ""}
                                                                                            onClick={!isSelected ? () => {
                                                                                                setSelectedPDFVersion(v);
                                                                                                setIsVersionDropdownOpen(false);
                                                                                            } : undefined}
                                                                                        >
                                                                                            {v.Title}
                                                                                        </li>
                                                                                    );
                                                                                })}
                                                                            </ul>
                                                                        )}
                                                                    </div>

                                                                </>
                                                            )}

                                                            <div>
                                                                <button onClick={callAIChat} className="medboard-ai-analyzer-button">AI Overview</button>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* Original/Translation tabs */}

                                                    {hasValue(AppContext.currentItem.TranslationMediaPath) ? <>

                                                        <div style={{ display: "flex", width: "100%", flexDirection: "row", marginBottom: "15px" }} >
                                                            <div onClick={() => setSelectedPDFTab("main")} style={{ cursor: "pointer", paddingRight: "8px", paddingLeft: "8px" }} className={selectedPDFTab == "main" ? "pdf-viewer-tab-selected" : "pdf-viewer-tab-unselected"}><i className="fas fa-file-alt"></i> Original</div>
                                                            <div onClick={() => setSelectedPDFTab("translation")} style={{ cursor: "pointer", paddingRight: "8px", paddingLeft: "8px" }} className={selectedPDFTab == "translation" ? "pdf-viewer-tab-selected" : "pdf-viewer-tab-unselected"}><i className="fas fa-language"></i> Translation</div>
                                                            <div style={{ flex: "1 1 0%", borderBottom: "2px solid rgb(240, 240, 240)" }}></div>
                                                        </div>

                                                    </> : null}



                                                    {selectedPDFTab === "main" ? (
                                                        <>
                                                                <div id="pdfviewerdiv" style={{ height: "100%", marginBottom: "30px" }}>
                                                                    <MedboardPdf
                                                                        key={`main-${AppContext.currentItem.Id}`}
                                                                        updater={firstEmitter}
                                                                        savedComments={[]}
                                                                        url={
                                                                            hasValue(selectedPDFVersion?.MediaPath)
                                                                                ? selectedPDFVersion.MediaPath
                                                                                : hasValue(AppContext.currentItem.MediaPath)
                                                                                    ? AppContext.currentItem.MediaPath
                                                                                    : "/Umbraco/Api/SurveilanceAppraisal/LoadPdf?surveillanceItemId=" +
                                                                                    AppContext.currentItem.MedboardResourceId
                                                                        }
                                                                        showHighlightsButton={false}
                                                                        showAnnotationsButton={false}
                                                                        containerHeight={"80vb"}
                                                                    />
                                                                </div>
                                                        </>
                                                    ) : null}


                                                    {selectedPDFTab == "translation" ? <>

                                                            {hasValue(AppContext.currentItem.TranslationMediaPath) ?
                                                                <div id="pdfviewerdiv" style={{ height: "100%", marginBottom: "30px" }}>
                                                                    <MedboardPdf
                                                                        key={`translation-${AppContext.currentItem.Id}`}
                                                                        updater={firstEmitter}
                                                                        savedComments={[]}
                                                                        url={AppContext.currentItem.TranslationMediaPath}
                                                                        showHighlightsButton={false}
                                                                        showAnnotationsButton={false}
                                                                        containerHeight={"80vb"}
                                                                    />
                                                                </div>
                                                                :
                                                                <div style={{ marginTop: "15px" }}>No pdf file found.</div>
                                                            }

                                                    </> : null}




                                                </div>

                                            </> : null}





                                            {/* FIELDS PANE */}
                                            {/* FIELDS PANE */}
                                            {/* FIELDS PANE */}

                                            <div id="fields-content" style={{ flex: 20, flexDirection: "column", paddingLeft: "10px", height: "96vh", overflowY: "auto", position: "relative", display: "flex" }}>

                                                <div id="multiple-contents" style={{ flex: 1, overflow: "auto", paddingRight: "15px", display: "flex", flexDirection: "column" }}>

                                                    <div style={{ display: "flex", marginBottom: "10px" }}>

                                                        <div style={{ flex: 1, marginRight: "20px" }}>
                                                            <h3>{AppContext.currentItem.Name}</h3>
                                                        </div>

                                                        <div style={{ marginRight: "5px" }}>
                                                            <button ref={contextMenuButton} className="close-button" onClick={openContextualMenu}>
                                                                <i className="fas fa-ellipsis-v"></i>
                                                            </button>
                                                        </div>

                                                        <div>
                                                            <button className="close-button" onClick={AppContext.closePane}>
                                                                <i className="fas fa-times"></i>
                                                            </button>
                                                        </div>

                                                    </div>



                                                    {/* TABS */}
                                                    {/* TABS */}
                                                    {/* TABS */}

                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            width: "100%",
                                                            flexDirection: "row",
                                                            marginBottom: "15px"
                                                        }}
                                                    >

                                                        <div
                                                           
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(visibleDetailsTab == "information"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => setVisibleDetailsTab("information")}
                                                        >
                                                            <i className="fas fa-info-circle g-mr-5"></i>  Details
                                                        </div>



                                                        <div
                                                           
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(visibleDetailsTab == "tasks"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => setVisibleDetailsTab("tasks")}
                                                        >
                                                            <i className="far fa-calendar-check g-mr-5"></i>  Tasks
                                                        </div>

                                                        {AppContext.currentItem.OtherVersions.length > 1 && (
                                                            <div
                                                            
                                                                style={{
                                                                    cursor: "pointer",
                                                                    paddingBottom: "3px",
                                                                    paddingLeft: "8px",
                                                                    paddingRight: "8px",
                                                                    ...(visibleDetailsTab === "otherversions"
                                                                        ? { borderBottom: "2px solid #00abff" }
                                                                        : { borderBottom: "2px solid #f0f0f0" })
                                                                }}
                                                                onClick={() => setVisibleDetailsTab("otherversions")}
                                                            >
                                                                <i className="far fa-file-archive g-mr-5"></i>  History
                                                            </div>
                                                        )}
                                                        <div
                                                           
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(visibleDetailsTab == "relatedreviews"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => setVisibleDetailsTab("relatedreviews")}
                                                        >
                                                            <i className="fas fa-random g-mr-5"></i>  Reviews
                                                        </div>


                                                        <div
                                                           
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(visibleDetailsTab == "comments"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => setVisibleDetailsTab("comments")}
                                                        >
                                                            <i className="fas fa-comments g-mr-5"></i> Comments
                                                        </div>


                                                        <div
                                                            
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(visibleDetailsTab == "linkedto"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => setVisibleDetailsTab("linkedto")}
                                                        >
                                                            <i className="fas fa-project-diagram g-mr-5"></i>  Linked to
                                                        </div>


                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(visibleDetailsTab == "attachments"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => setVisibleDetailsTab("attachments")}
                                                        >
                                                            <i className="fas fa-paperclip g-mr-5"></i>  Attachments
                                                        </div>
                                                           

                                                            <div
                                                                
                                                                style={{
                                                                    cursor: "pointer",
                                                                    paddingBottom: "3px",
                                                                    paddingLeft: "8px",
                                                                    paddingRight: "8px",
                                                                    ...(visibleDetailsTab == "audit"
                                                                        ? { borderBottom: "2px solid #00abff" }
                                                                        : { borderBottom: "2px solid #f0f0f0" })
                                                                }}
                                                                onClick={() => setVisibleDetailsTab("audit")}
                                                            >
                                                                <i className="fas fa-history g-mr-5"></i> Activity Log
                                                            </div>

                                                        <div
                                                        
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingBottom: "3px",
                                                                paddingLeft: "8px",
                                                                paddingRight: "8px",
                                                                ...(visibleDetailsTab == "aichat"
                                                                    ? { borderBottom: "2px solid #00abff" }
                                                                    : { borderBottom: "2px solid #f0f0f0" })
                                                            }}
                                                            onClick={() => { setAutoCallOverviewFunction(false); setVisibleDetailsTab("aichat"); }}
                                                        >
                                                            <img src="/assets/images/stars-stroke-rounded-solid.svg" className="ai-icon" style={{ width: "19px", marginTop: "-3px", marginRight: "5px" }} /> AI
                                                        </div>




                                                        <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>

                                                    </div>




                                                    {/* CONTENT */}
                                                    {/* CONTENT */}
                                                    {/* CONTENT */}



                                                    <div style={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: "start", overflow: "auto" }}>




                                                        {/* INFORMATION FORMS FIELDS */}

                                                        {visibleDetailsTab == "information" &&

                                                            <div style={{ height: "100%", overflow: "auto" }}>

                                                                <div style={{ marginBottom: "40px" }}>

                                                                    {/* Form field: Title */}
                                                                    <div className="view-task-field">
                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title">Title</div>
                                                                            <div className="view-task-field-value">
                                                                                {AppContext.currentItem.Name}
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    {/* Form field: Country */}
                                                                    <div className="view-task-field">
                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title">Country</div>
                                                                            <div className="view-task-field-value">
                                                                                <FieldTypes.FieldType_CountryWithFlag
                                                                                    value={{
                                                                                        Country: AppContext.currentItem.Country,
                                                                                        CountryFlag: AppContext.currentItem.CountryFlag
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    {/* Form field: Regulatory Area */}
                                                                    <div className="view-task-field">
                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title">Regulatory Area</div>
                                                                            <div className="view-task-field-value">
                                                                                {AppContext.currentItem.RegulatoryArea}
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    {/* Form field: Type */}
                                                                    <div className="view-task-field">
                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title">Type</div>
                                                                            <div className="view-task-field-value">
                                                                                {AppContext.currentItem.Type}
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    {/* Form field: Publication Date */}
                                                                    <div className="view-task-field">
                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title">Publication Date</div>
                                                                            <div className="view-task-field-value">
                                                                                <FieldTypes.FieldType_SimpleDate value={AppContext.currentItem.Date} />
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    {/* Form field: Stage */}
                                                                    <div className="view-task-field">
                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title">Stage</div>
                                                                            <div className="view-task-field-value">
                                                                                <FieldTypes.FieldType_Compliance_Stage value={AppContext.currentItem.Stage} />
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    {/* Form field: Legal Manufacturer */}
                                                                    <div className="view-task-field">
                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title">Legal Manufacturer</div>
                                                                            <div className="view-task-field-value">
                                                                                <span style={{ fontWeight: "bold" }}>{currentLegalManufacturer}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>






                                                                    {/* Form field: Compliance Status */}
                                                                    <div className="view-task-field">
                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title">Compliance Status</div>
                                                                            <div className="view-task-field-value">


                                                                                {AppContext.isEditingField.compliance_status === false ? (
                                                                                    <>
                                                                                        <span
                                                                                            className="editable-field-span editable-field-span-complex"
                                                                                            onClick={(e) =>
                                                                                                AppContext.enableTaskFormFieldEdit("compliance_status", e)
                                                                                            }
                                                                                        >
                                                                                            <FieldTypes.FieldType_Compliance_Status value={AppContext.currentItem.Status} />

                                                                                        </span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span>
                                                                                            <select
                                                                                                value={AppContext.currentItem.Status}
                                                                                                onBlur={() =>
                                                                                                    AppContext.disableAllItemFormFieldsEdit()
                                                                                                }
                                                                                                onChange={(e) => {
                                                                                                    AppContext.setCurrentItem({
                                                                                                        ...AppContext.currentItem,
                                                                                                        Status: e.target.value
                                                                                                    });
                                                                                                }}
                                                                                            >
                                                                                                {compliance_statuses.map((compliance_status, index) => (
                                                                                                    <option key={index} value={compliance_status.id}>
                                                                                                        {compliance_status.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </span>
                                                                                    </>
                                                                                )}


                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    {/* Form field: Open Tasks */}
                                                                    {/* 
                                                            <div className="view-task-field">
                                                                <div className="view-task-field-line">
                                                                    <div className="view-task-field-title">Open Tasks</div>
                                                                    <div className="view-task-field-value">
                                                                        <FieldTypes.FieldType_Open_Tasks value={AppContext.currentItem.TaskCount} row={AppContext.currentItem} entityType={AppContext.entityType} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            */}

                                                                        {/* Form field: AssignedTo */}
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">Assigned to</div>
                                                                                <div className="view-task-field-value">


                                                                                    {!AppContext.isEditingField.assignee ? (
                                                                                        <>
                                                                                            <span
                                                                                                className="editable-field-span editable-field-span-complex"
                                                                                                onClick={(e) =>
                                                                                                    AppContext.enableTaskFormFieldEdit("assignee", e)
                                                                                                }
                                                                                            >
                                                                                                {AppContext.currentItem.Assignee ? (
                                                                                                    <FieldTypes.FieldType_User
                                                                                                        value={AppContext.currentItem.Assignee}
                                                                                                        users={AppContext.users}
                                                                                                    />
                                                                                                ) : (
                                                                                                    "Select User"
                                                                                                )}
                                                                                            </span>
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <span>
                                                                                                <select
                                                                                                    value={AppContext.currentItem.Assignee}
                                                                                                    onBlur={() =>
                                                                                                        AppContext.disableAllItemFormFieldsEdit()
                                                                                                    }
                                                                                                    onChange={(e) => {
                                                                                                        AppContext.setCurrentItem({
                                                                                                            ...AppContext.currentItem,
                                                                                                            Assignee: e.target.value
                                                                                                        });
                                                                                                    }}
                                                                                                    >
                                                                                                        <option value="">Select User</option>
                                                                                                    {AppContext.users.map((user, index) => (
                                                                                                        <option key={index} value={user.Id}>
                                                                                                            {user.Name}
                                                                                                        </option>
                                                                                                    ))}
                                                                                                </select>
                                                                                            </span>
                                                                                        </>
                                                                                    )}


                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    {/* Form field: ExternalUrl */}
                                                                    {AppContext.currentItem.ExternalUrl ?
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">Evidence Link</div>
                                                                                <div className="view-task-field-value">
                                                                                    <FieldTypes.Link name={AppContext.currentItem.ExternalUrl} url={AppContext.currentItem.ExternalUrl} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                    }



                                                                    {/* Form field: PDF Link for default PDF */}
                                                                    {(hasValue(AppContext.currentItem.MediaPath) || hasValue(AppContext.currentItem.MedboardResourceId)) ?
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">
                                                                                    {hasValue(AppContext.currentItem.MediaPath) ? "Authority PDF" : null}
                                                                                    {hasValue(AppContext.currentItem.MedboardResourceId) ? "Uploaded PDF" : null}
                                                                                </div>
                                                                                <div className="view-task-field-value">
                                                                                    <FieldTypes.PdfLink name="PDF" url={hasValue(AppContext.currentItem.MediaPath) ? AppContext.currentItem.MediaPath : "/Umbraco/Api/SurveilanceAppraisal/LoadPdf?surveillanceItemId=" + AppContext.currentItem.MedboardResourceId} />

                                                                                    {/*Delete file button*/}
                                                                                    {hasValue(AppContext.currentItem.MedboardResourceId) ?
                                                                                        <>
                                                                                            {AppContext.userRole == "Admin" ? <>

                                                                                                {!showDeleteFileConfirmation &&
                                                                                                    <div style={{ flex: 1, marginLeft: "25px" }}>
                                                                                                        <i title="Delete file" onClick={() => setShowDeleteFileConfirmation(!showDeleteFileConfirmation)} className="pointer circle-delete-button fas fa-times-circle"></i>
                                                                                                    </div>
                                                                                                }

                                                                                                {showDeleteFileConfirmation &&
                                                                                                    <div style={{ flex: 1, marginLeft: "25px", minWidth: "300px", display: "flex", flexDirection: "row" }}>
                                                                                                        <span>Are you sure you want to delete this file?</span>
                                                                                                        <div className="pointer" style={{ alignItems: "center", display: "flex", marginLeft: "15px", borderRadius: "10px", padding: "2px 10px", backgroundColor: "#ccc" }} onClick={() => setShowDeleteFileConfirmation(false)} >No</div>

                                                                                                        {isDeletingFile ? <LoadingSpinnerImage /> :
                                                                                                            <div className="pointer context-delete-option" style={{ alignItems: "center", display: "flex", marginLeft: "15px", borderRadius: "10px", padding: "2px 10px" }} onClick={deleteCurrentFile} >Yes</div>
                                                                                                        }

                                                                                                    </div>
                                                                                                }

                                                                                            </> : null}
                                                                                        </>

                                                                                        : null}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                    }



                                                                    {/* Show upload block */}
                                                                        {(!hasValue(AppContext.currentItem.MediaPath) && !hasValue(AppContext.currentItem.MedboardResourceId)) ? (
                                                                            <div className="view-task-field">
                                                                                <div className="view-task-field-line">
                                                                                    <div className="view-task-field-title">Upload PDF</div>
                                                                                    <div className="view-task-field-value">

                                                                                        {isUploadingFile ? (
                                                                                            <LoadingSpinnerImage />
                                                                                        ) : (
                                                                                            <div style={{ display: "flex", width: "100%", marginTop: "10px" }}>
                                                                                                <div
                                                                                                    {...getRootProps()}
                                                                                                    style={{
                                                                                                        display: "flex",
                                                                                                        flexDirection: "column",
                                                                                                        alignItems: "center",
                                                                                                        justifyContent: "center",
                                                                                                        padding: "12px 8px",
                                                                                                        border: "2px dashed",
                                                                                                        borderColor: isDragActive ? "#3498db" : "rgb(209, 213, 219)",
                                                                                                        borderRadius: "8px",
                                                                                                        cursor: "pointer",
                                                                                                        backgroundColor: isDragActive ? "rgb(243, 244, 246)" : "rgb(249, 250, 251)",
                                                                                                        transition: "all 0.2s ease",
                                                                                                        width: "60%" 
                                                                                                    }}
                                                                                                    onMouseEnter={(e) => {
                                                                                                        if (!isDragActive) {
                                                                                                            e.currentTarget.style.backgroundColor = "rgb(243, 244, 246)";
                                                                                                            e.currentTarget.style.borderColor = "#3498db";
                                                                                                        }
                                                                                                    }}
                                                                                                    onMouseLeave={(e) => {
                                                                                                        if (!isDragActive) {
                                                                                                            e.currentTarget.style.backgroundColor = "rgb(249, 250, 251)";
                                                                                                            e.currentTarget.style.borderColor = "rgb(209, 213, 219)";
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    <input {...getInputProps()} />

                                                                                                    {/* Consistent Upload Icon */}
                                                                                                    <i
                                                                                                        className="fas fa-upload"
                                                                                                        style={{
                                                                                                            fontSize: "24px",
                                                                                                            color: isDragActive ? "#3498db" : "rgb(156, 163, 175)",
                                                                                                            marginBottom: "8px"
                                                                                                        }}
                                                                                                    ></i>

                                                                                                    {/* Consistent Text */}
                                                                                                    <span style={{ textAlign: "center", fontSize: "12px", color: "rgb(75, 85, 99)" }}>
                                                                                                        {isDragActive
                                                                                                            ? "Drop the file here"
                                                                                                            : "Click to select a file or drag and drop"}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : null}




                                                                    {/* Form field: ReplacedBy */}
                                                                    {AppContext.currentItem.ReplacedBy ?
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">Replaced By</div>
                                                                                <div className="view-task-field-value">
                                                                                    {AppContext.currentItem.ReplacedBy}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                    }




                                                                    {/* Form field: Replacing */}
                                                                    {AppContext.currentItem.Replacing.length > 0 ?
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">Replacing</div>
                                                                                <div className="view-task-field-value">
                                                                                    <div style={{
                                                                                        display: "flex",
                                                                                        flexDirection: "column"
                                                                                    }}>
                                                                                        {AppContext.currentItem.Replacing.map((item) =>
                                                                                            <div style={{
                                                                                                marginBottom: "15px"
                                                                                            }}>{item}</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                    }

                                                                    {/* 2. Render the field only if the date exists */}
                                                                    {entryDate && (
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">{entryDate.DateTitle}</div>
                                                                                <div className="view-task-field-value">
                                                                                    {/* The Date Component */}
                                                                                    <div style={{
                                                                                        display: "flex", flexDirection: "column",
                                                                                        marginTop: "9px"
                                                                                    }}>
                                                                                        <strong> <FieldTypes.FieldType_SimpleDate value={entryDate.DateValue} />  </strong>

                                                                                        {entryDate?.DateDescription && (
                                                                                            <div>
                                                                                                {entryDate.DateDescription}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {/* 2. Render as a single field with a list on the right */}
                                                                    {AppContext.currentItem.ApplicabilityDates && AppContext.currentItem.ApplicabilityDates.length > 0 && (
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">Applicability Dates</div>
                                                                                <div className="view-task-field-value">
                                                                                    <ul style={{
                                                                                        listStyleType: "disc",
                                                                                        margin: 0,
                                                                                        paddingLeft: "15px",
                                                                                        marginTop: "9px"
                                                                                    }}>
                                                                                        {AppContext.currentItem.ApplicabilityDates.map((item, index) => (
                                                                                            <li key={index} style={{ marginBottom: "12px" }}>
                                                                                                <div style={{
                                                                                                    display: "flex",
                                                                                                    flexDirection: "column",
                                                                                                    alignItems: "flex-start" // Ensures everything stays left-aligned
                                                                                                }}>
                                                                                                    {/* The Date and specific Title */}
                                                                                                    <div style={{ marginBottom: "2px" }}>
                                                                                                        <strong>
                                                                                                            <FieldTypes.FieldType_SimpleDate value={item.DateValue} />:
                                                                                                        </strong> {item.DateTitle}
                                                                                                    </div>

                                                                                                    {/* The Description - Changed span to div for better block behavior */}
                                                                                                    {item?.DateDescription && (
                                                                                                        <div style={{
                                                                                                            paddingLeft: "4px"
                                                                                                        }}>
                                                                                                            {item.DateDescription}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}


                                                                    {/* 2. Render the field only if the date exists */}
                                                                    {endDate && (
                                                                        <div className="view-task-field">
                                                                            <div className="view-task-field-line">
                                                                                <div className="view-task-field-title">{endDate.DateTitle}</div>
                                                                                <div className="view-task-field-value">
                                                                                    <div style={{
                                                                                        display: "flex", flexDirection: "column",
                                                                                        marginTop: "9px"
                                                                                    }}>
                                                                                        {/* The Date Component wrapped to ensure block behavior */}
                                                                                        <div>
                                                                                            <strong>  <FieldTypes.FieldType_SimpleDate value={endDate.DateValue} />  </strong>
                                                                                        </div>

                                                                                        {/* The Description added immediately after */}
                                                                                        {endDate?.DateDescription && (
                                                                                            <div>
                                                                                                {endDate.DateDescription}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {/* Form field: Tags */}
                                                                    <div className="view-task-field">

                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title">Tags</div>
                                                                            <div className="view-task-field-value">

                                                                                <div style={{
                                                                                    display: "flex",
                                                                                    flexWrap: "wrap",
                                                                                }}>
                                                                                    <Tags context={AppContext} objectType={AppContext.entityType} />
                                                                                </div>

                                                                            </div>
                                                                        </div>

                                                                    </div>



                                                                    {/* Form field: Legal Manufacturer */}
                                                                    <div className="view-task-field">

                                                                        <div className="view-task-field-line">
                                                                            <div className="view-task-field-title g-mt-20">Associated Legal Manufacturers</div>
                                                                            <div className="view-task-field-value">

                                                                                <div style={{
                                                                                    display: "flex",
                                                                                    flexWrap: "wrap",
                                                                                    width: "100%"
                                                                                }}>
                                                                                    <RelatedLegalManufacturers globalContext={AppContext} />
                                                                                </div>

                                                                            </div>
                                                                        </div>

                                                                    </div>




                                                                        {/* CUSTOM USER FIELDS */}
                                                                        {/* CUSTOM USER FIELDS */}
                                                                        {/* CUSTOM USER FIELDS */}
                                                                        {AppContext.enableCustomFields ?
                                                                            <FieldTypes.FieldType_CustomUserFields globalContext={AppContext} />
                                                                            : null}

                                                                </div>

                                                            </div>
                                                        }




                                                        {/* COMMENTS */}

                                                        {visibleDetailsTab == "comments" &&

                                                            <div style={{ height: "100%", overflow: "auto" }}>

                                                                <div style={{ marginBottom: "20px" }}>
                                                                    <CommentsList entityType={AppContext.entityType} entityId={AppContext.currentItem.Id} userList={AppContext.users} currentUserId={AppContext.currentUserId} />
                                                                </div>

                                                            </div>

                                                        }

                                                        {/* OTHER VERSIONS */}

                                                        {visibleDetailsTab == "otherversions" &&
                                                            <div style={{ height: "100%", overflow: "auto" }}>
                                                                    <FieldTypes.RegulatoryOtherVersions otherVersions={AppContext.currentItem.OtherVersions} globalContext={AppContext} />
                                                            </div>
                                                        }



                                                        {/* RELATED REVIEWS */}

                                                        {visibleDetailsTab == "relatedreviews" &&
                                                            <div style={{ height: "100%", overflow: "auto" }}>
                                                                <FieldTypes.RelatedReviews relatedReviews={AppContext.currentItem.RelatedAppraisals} />
                                                            </div>
                                                        }




                                                        {/* TASKS */}

                                                        {visibleDetailsTab == "tasks" &&

                                                            <div style={{ height: "100%", overflow: "auto" }}>
                                                                <TaskManager
                                                                    emitter={new EventEmitter()}
                                                                    paramEntityType="compliance-regulatorydocuments"
                                                                    paramEntityId={AppContext.currentItem.Id}
                                                                    paramCompanyId={AppContext.currentCompanyId}
                                                                    paramUserId={AppContext.currentUserId}
                                                                    paramIsSlimVersion={true}
                                                                    paramExternalLinkedObjects={taskManagerExternalLinkedObjects}
                                                                    paramHasLimitedWidth={true} />
                                                            </div>
                                                        }




                                                        {/* LINKED TO */}

                                                        {visibleDetailsTab == "linkedto" &&
                                                            <div style={{ height: "100%", overflow: "auto" }}>
                                                                <EntityAssociation context={AppContext} />
                                                            </div>
                                                        }


                                                        {/* ATTACHMENTS */}

                                                        {visibleDetailsTab == "attachments" && <>
                                                            <div style={{ height: "100%", overflow: "auto" }}>
                                                                <Attachments EntityType={AppContext.entityType} EntityId={AppContext.currentItem.Id} users={AppContext.users} userRole={AppContext.userRole} />
                                                            </div>
                                                            </>}

                                                            {/* AUDIT TRIAL */}

                                                            {visibleDetailsTab == "audit" && <>
                                                                <div style={{ height: "100%", overflow: "auto" }}>
                                                                    <Audit EntityType={AppContext.entityType} EntityId={AppContext.currentItem.Id} users={AppContext.users} />
                                                                </div>
                                                            </>}


                                                            

                                                        {/* AI CHAT */}
                                                        {/* ... */}
                                                        {/* this is always drawn but controlled with css display to it doesn't clear chat text on tab change */}

                                                        <div style={{ marginBottom: "10px", flex: 1, display: visibleDetailsTab == "aichat" ? "block" : "none" }}>


                                                                {hasAIChat ? <>
                                                                    <div id="aichat-pane" style={{ flex: 1, padding: "0px 10px", borderRight: "2px solid #f0f0f0", height: "100%" }}>

                                                                        <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }} >
                                                                            <AIChat
                                                                                AppContext={AppContext}
                                                                                key={componentKey}
                                                                                entityType="compliance-regulatorydocuments"
                                                                                entityId={AppContext.currentItem.Id}
                                                                                uniqueId={AppContext.currentItem.UniqueId}
                                                                                embeddedAIComponent={true}
                                                                                autoCallOverviewFunction={autoCallOverviewFunction}
                                                                                enableAIOverviewButton={true}
                                                                                enableComparisonButton={true}
                                                                                enableRequirementsButton={true}
                                                                                enableUserChat={true}
                                                                                otherDocVersions={
                                                                                    AppContext.currentItem?.OtherVersions?.length > 1 &&
                                                                                    AppContext.currentItem.OtherVersions.some(doc => doc?.MediaPath != null && doc?.MediaPath != "" && doc.UniqueId != AppContext.currentItem.UniqueId)
                                                                                }
                                                                                filePath={hasValue(selectedPDFVersion?.MediaPath)
                                                                                    ? selectedPDFVersion.MediaPath
                                                                                    : hasValue(AppContext.currentItem.MediaPath)
                                                                                        ? AppContext.currentItem.MediaPath
                                                                                        : "/Umbraco/Api/SurveilanceAppraisal/LoadPdf?surveillanceItemId=" +
                                                                                        AppContext.currentItem.MedboardResourceId}
                                                                                translationMediaPath={selectedPDFVersion?.TranslationMediaPath}
                                                                            />
                                                                        </div>
                                                                    </div>


                                                            </> : <>
                                                                <div>AI Tools are disabled because no PDF file was found</div>
                                                            </>}

                                                        </div>

                                                    </div>



                                                </div>



                                                <div id="buttom-bar" style={{ borderTop: "1px solid #f0f0f0" }}>

                                                    {/* FORMS BUTTONS */}

                                                    <div className="action-button-bar">

                                                        {AppContext.userRole == "Admin" ? <>


                                                            <div className="action-button-bar-left">

                                                                    <button
                                                                        className="action-button cancel-button"
                                                                        onClick={AppContext.closePane}
                                                                    >
                                                                        Cancel
                                                                    </button>

                                                            </div>



                                                            <div className="action-button-bar-center">



                                                            </div>



                                                            <div className="action-button-bar-right">
                                                                    {!isSavingItem ? (
                                                                        <>
                                                                            <button
                                                                                className="action-button save-button"
                                                                                onClick={saveCurrentItem}
                                                                            >
                                                                                Save
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <LoadingSpinnerImage />
                                                                        </>
                                                                    )}
                                                                    <span
                                                                        className={`${isShowingSaveMessage
                                                                            ? "save-message-shown"
                                                                            : "save-message-hidden"
                                                                            }`}
                                                                        onTransitionEnd={() => setIsShowingSaveMessage(false)}
                                                                    >
                                                                        Save successful!
                                                                    </span>

                                                            </div>



                                                        </> : null}

                                                    </div>


                                                </div>




                                            </div>

                                        </div>

                                        : null}




                                        {/* COMPARISON FULL SCREEN */}
                                        {/* COMPARISON FULL SCREEN */}
                                        {/* COMPARISON FULL SCREEN */}




                                        {screenType == "comparison" ?

                                            <ComplianceComparison AppContext={AppContext} screenType={screenType} selectedPDFVersion={selectedPDFVersion} selectedPDFVersionComparison={selectedPDFVersionComparison} closePopup={closeComplianceComparisonPopup } />

                                            : null}


                                </>
                            )}

                        </div>



                    </div>
                </div>
            
            : null}



            




            {showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >
                    {/* DELETE */}
                    {AppContext.userRole === "Admin" ? (
                        !AppContext.isShowingDeleteConfirmation ? (
                            <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}>
                                <i className="far fa-trash-alt"></i> Delete this item
                            </div>
                        ) : (
                            AppContext.isDeletingItem ? (
                                <LoadingSpinnerImage />
                            ) : (
                                <div className="context-menu-option context-delete-option" onClick={AppContext.deleteCurrentItem}>
                                    <i className="far fa-trash-alt"></i> Confirm delete?
                                </div>
                            )
                        )
                    ) : (
                        <div className="context-menu-option disabled">
                            <i className="far fa-trash-alt"></i> Delete (No Permission)
                        </div>
                    )}

                </div>
            )}
















        </>
    );
};







export default ItemDetailsPane;